import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, ListGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Accountant_Task_Action } from '../Redux/Actions/Accountant_Tasks_Action';
import { Notify } from '../Utility/Notify';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export const AccountantTasksPage = () => {
  const [text, setText] = useState('');
  const [date, setDate] = useState('');
  const [taskNoteList, setTaskNoteList] = useState([]);
  const [saved, setSaved] = useState(false);
  const [loading, setloading] = useState(true);

  const dispatch = useDispatch();

  const [userlogin, setUserLogin] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const theme = useSelector((state) => state.theme?.mode || 'light'); // ⬅️ جلب الثيم الحالي

  const handleAdd = () => {
    if (text.trim() && date) {
      const newItem = { text, date };
      setTaskNoteList([...taskNoteList, newItem]);
      setText('');
      setDate('');
      setSaved(false);
    }
  };

  const handleSave = async () => {
    try {
      setloading(true);
      const formattedData = taskNoteList.map((item) => ({
        Task: item.text,
        date: item.date,
        Added_By: userlogin?.data?._id,
      }));

      for (let task of formattedData) {
        await dispatch(Add_Accountant_Task_Action(task));
      }
      setloading(false);
      setSaved(true);
    } catch (error) {
      console.error('Error saving tasks:', error);
    }
  };

  const resAdd = useSelector((state) => state.AllTasks_Reducer.TAsk);

  useEffect(() => {
    if (loading === false) {
      if (resAdd && resAdd.status === 201) {
        Notify('success', 'Task Added Successfully', 'success');
        setTaskNoteList([]);
      } else {
        Notify('error', 'Task Failed', 'error');
      }
    }
  }, [loading]);

  const handleDelete = (index) => {
    const newList = [...taskNoteList];
    newList.splice(index, 1);
    setTaskNoteList(newList);
    setSaved(false);
  };

  return (
    <Container className="startpage fade-in" style={{ color: theme === 'dark' ? '#fff' : '#333' }}>
      <div className="mb-3">
        <Link
          to="/LeadsForAccountant"
          style={{
            textDecoration: 'none',
            color: theme === 'dark' ? '#66B2FF' : '#0F7687',
            fontWeight: 'bold',
          }}
        >
          Home
        </Link>
        <KeyboardDoubleArrowRightIcon />
        <span style={{ fontWeight: 'bold', color: theme === 'dark' ? '#ccc' : '#333' }}>
          Add Tasks And Notes
        </span>
      </div>

      <hr style={{ borderColor: theme === 'dark' ? '#555' : '#ccc' }} />

      <div
        className="p-4 shadow-sm mb-4"
        style={{
          background: theme === 'dark' ? '#333' : '#f8f9fa',
          borderRadius: '8px',
        }}
      >
        <h3 className="mb-4" style={{ color: theme === 'dark' ? '#4FC3F7' : '#0d6efd' }}>
          📋 Accountant Tasks & Notes
        </h3>

        <Row className="align-items-end g-3 w-100">
          <Col md={12}>
            <Form.Label>✍️ Task / Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Write your task or note here..."
              value={text}
              onChange={(e) => setText(e.target.value)}
              style={{
                width: '100%',
                backgroundColor: theme === 'dark' ? '#444' : '#fff',
                color: theme === 'dark' ? '#fff' : '#000',
              }}
            />

            <div className="mt-3">
              <Form.Label>📅 Date</Form.Label>
              <Form.Control
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                style={{
                  backgroundColor: theme === 'dark' ? '#444' : '#fff',
                  color: theme === 'dark' ? '#fff' : '#000',
                }}
              />
            </div>
          </Col>

          <Col md={12} className="d-flex gap-2 align-items-end justify-content-end">
            <Button
              variant="primary"
              onClick={handleAdd}
              disabled={!text || !date}
              className="my-2 w-50"
            >
              ➕ Add
            </Button>
          </Col>
        </Row>
      </div>

      {taskNoteList.length > 0 && (
        <div
          className="p-3 shadow-sm"
          style={{
            background: theme === 'dark' ? '#2c2c2c' : '#fff',
            borderRadius: '8px',
            color: theme === 'dark' ? '#eee' : '#000',
          }}
        >
          <h5 className="mb-3" style={{ color: theme === 'dark' ? '#ddd' : '#6c757d' }}>
            📝 Your Notes
          </h5>
          <ListGroup variant={theme === 'dark' ? 'dark' : 'light'}>
            {taskNoteList.map((item, idx) => (
              <ListGroup.Item
                key={idx}
                className="d-flex justify-content-between align-items-start"
                style={{
                  backgroundColor: theme === 'dark' ? '#424242' : '#fff',
                  color: theme === 'dark' ? '#fff' : '#000',
                }}
              >
                <div>
                  <div style={{ whiteSpace: 'pre-line' }}>
                    <strong>{item.text}</strong>
                  </div>
                  <small className="text-muted">
                    📅 {new Date(item.date).toLocaleDateString()}
                  </small>
                </div>
                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(idx)}>
                  🗑️
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      )}

      <Button
        variant="success"
        onClick={handleSave}
        disabled={taskNoteList.length === 0}
        className="text-center w-50 my-3"
      >
        💾 Save
      </Button>

      {saved && (
        <div className="mt-3 text-success text-center fw-bold">✅ Data has been saved.</div>
      )}
    </Container>
  );
};
